export enum Stages {
  Applied = 'Applied',
  Screening = 'Screening',
  Interview = 'Interview',
  Decision = 'Decision',
  Offer = 'Offer',
  Hired = 'Hired',
  PendingRejection = 'PendingRejection',
  Closed = 'Closed',
  Rejected = 'Rejected',
}
